module.exports = __webpack_public_path__ + "img/vue2-corpsavant_bleu.46e82f54.png";